;(function () {
    function SearchAutoCompleteController(form) {
        /**
         * local object availability
         * @type {navigation}
         * @private
         */
        var _this = this

        this.name = Date.now()

        /**
         * Search form
         * @type {Element}
         */
        this.form = form

        /**
         * Search term input field
         * @type {Element}
         */
        this.input = form.querySelector('[data-autocomplete-source]')

        /**
         * List element for displaying current completions
         * @type {Element}
         */
        this.completions = form.querySelector('[rel="search-completions"]')

        /**
         * Maximum amount of displayed completions
         * @type {number}
         */
        this.COMPLETIONS_MAX_AMOUNT = 6

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.initKeySelection()
            const autocompleteSource = _this.input.getAttribute('data-autocomplete-source')
            _this.initAutoCompletion(autocompleteSource)
        }

        /**
         * Initialize auto completion for search input
         * @param autocompleteSource
         */
        this.initAutoCompletion = function (autocompleteSource) {
            _this.input.onkeyup = function (e) {
                // Reload on any key except up and down arrows used for selection
                if (e.keyCode !== 40 && e.keyCode !== 38) {
                    var term = _this.input.value
                    if (term.length > 2) {
                        _this.getCompletions(autocompleteSource, term)
                    } else {
                        _this.removeCompletions()
                    }
                }
            }
        }

        /**
         * Receive new completions from controller
         * @param source
         * @param term
         */
        this.getCompletions = function (source, term) {
            var xmlhttp = new XMLHttpRequest()

            xmlhttp.onreadystatechange = function () {
                if (xmlhttp.readyState == XMLHttpRequest.DONE) {
                    if (xmlhttp.status == 200) {
                        response = JSON.parse(xmlhttp.responseText)
                        if (response.completions !== null) {
                            _this.setNewCompletions(_this.processCompletions(response.completions))
                        }
                    } else {
                        _this.removeCompletions()
                    }
                }
            }
            xmlhttp.open('GET', source + '&term=' + term, true)
            xmlhttp.send()
        }

        /**
         * Activate the received completions
         * @param completions
         */
        this.setNewCompletions = function (completions) {
            _this.removeCompletions()
            completions.forEach(function (element) {
                singleCompletion = document.createElement('li')
                singleCompletion.innerText = element
                _this.completions.insertAdjacentElement('beforeend', singleCompletion)
            })
            _this.initCompletions()
        }

        /**
         * Sorts the completions by the amount of words and shortens the list according to settings
         * @param completions
         * @returns {*}
         */
        this.processCompletions = function (completions) {
            completions = _this.filterCompletions(completions)
            completionsInWords = _this.sortCompletions(completions)
            return completions.slice(0, _this.COMPLETIONS_MAX_AMOUNT)
        }

        /**
         * Completions containing numbers are removed since the removal of html tags is not working well for superscript numbers
         */
        this.filterCompletions = function (completions) {
            return completions.filter(function (completion) {
                return !/\d/.test(completion)
            })
        }

        /**
         * Sorts completions by the length of the string
         * So the shortest completions will be displayed first
         */
        this.sortCompletions = function (completions) {
            return completions.sort(function (firstElement, secondElement) {
                return firstElement.length - secondElement.length
            })
        }

        /**
         * Removes all currently displayedCompletions
         */
        this.removeCompletions = function () {
            while (_this.completions.firstChild) {
                _this.completions.removeChild(_this.completions.lastChild)
            }
        }

        /**
         * Initialize click handler for completions
         */
        this.initCompletions = function () {
            _this.completions.childNodes.forEach(function (completion) {
                completion.addEventListener('click', function () {
                    _this.input.value = completion.textContent
                    _this.form.submit()
                })
            })
        }

        /**
         * Adds event listeners for arrow up and down keys
         */
        this.initKeySelection = function () {
            window.addEventListener('keydown', function (e) {
                // arrow down
                if (e.keyCode === 40) {
                    _this.selectNextCompletion()
                }
                // arrow up
                if (e.keyCode === 38) {
                    _this.selectPreviousCompletion()
                }
            })
        }

        /**
         * Selects the next completion if available
         */
        this.selectNextCompletion = function () {
            var selectedCompletion = _this.completions.querySelector('[rel="search-selected-completion"]')
            if (selectedCompletion == null && _this.completions.firstChild !== null) {
                newCompletion = _this.completions.firstChild
                _this.switchSelectedCompletion(null, newCompletion)
            } else {
                if (selectedCompletion !== null) {
                    const newCompletion = selectedCompletion.nextSibling
                    if (newCompletion !== null) {
                        _this.switchSelectedCompletion(selectedCompletion, newCompletion)
                        _this.input.value = newCompletion.textContent
                    }
                }
            }
        }

        /**
         * Selects the previous completion if available
         */
        this.selectPreviousCompletion = function () {
            var selectedCompletion = _this.completions.querySelector('[rel="search-selected-completion"]')
            if (selectedCompletion !== null && selectedCompletion.previousSibling !== null) {
                const newCompletion = selectedCompletion.previousSibling
                _this.switchSelectedCompletion(selectedCompletion, newCompletion)
                _this.input.value = newCompletion.textContent
            }
        }

        /**
         * Deactivates the current Completion and selects a new one
         * @param currentCompletion
         * @param newCompletion
         */
        this.switchSelectedCompletion = function (currentCompletion, newCompletion) {
            if (currentCompletion !== null) {
                currentCompletion.removeAttribute('rel')
                currentCompletion.classList.remove('search-selected-completion')
            }
            newCompletion.classList.add('search-selected-completion')
            newCompletion.setAttribute('rel', 'search-selected-completion')
        }

        /**
         * initialize call navigation
         */
        _this.init()
    }

    window.Energy = window.Energy || {}

    window.Energy.SearchAutoCompleteController = SearchAutoCompleteController
})()

window.Energy.initSearchAutoCompleteController = function () {
    var forms = document.querySelectorAll('[rel="search-form"]')
    for (var i = 0; i < forms.length; i++) {
        var form = forms[i]
        new window.Energy.SearchAutoCompleteController(form)
    }
}

if (document.readyState != 'loading') {
    window.Energy.initSearchAutoCompleteController()
} else {
    document.addEventListener('DOMContentLoaded', function () {
        window.Energy.initSearchAutoCompleteController()
    })
}
